module.exports = __webpack_public_path__ + "img/中国基金报@2x.dc6479b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/中国基金报@2x.png
// module id = o8n2
// module chunks = 3